import { UrlAliasList, UrlAliasEdit, UrlAliasCreate } from './pages';
import Paths from './paths';
import { default as Translations } from './lang/hu';

export default {
    pages: {
        UrlAliasList,
        UrlAliasEdit,
        UrlAliasCreate,
    },
    paths: {
        ...Paths,
    },
    translations: {
        ...Translations,
    },
    name: 'urlAlias',
    icon: 'fa-exchange-alt',
};

export { default as Paths } from './paths';



// WEBPACK FOOTER //
// ./src/modules/UrlAlias/index.ts